import React from 'react';
import { Link } from 'react-router-dom';
import LoginButton from '../../components/auth/LoginButton';
import { PAGES } from '../../seo/documentHead';

/**
 * Register page component that redirects users to Google OAuth for account creation
 * Since we're using Google OAuth, registration and login use the same flow
 */
const RegisterPage: React.FC = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4 p-md-5">
              <div className="text-center mb-4">
                <h1 className="h2 fw-bold">{PAGES['/register'].h1}</h1>
                <p className="text-muted">{PAGES['/register'].intro}</p>
              </div>
              
              <div className="d-grid gap-3">
                <LoginButton 
                  label="Sign up with Google" 
                  className="btn btn-primary btn-lg"
                />
                
                <div className="text-center mt-3">
                  <p className="small text-muted">
                    By signing up, you agree to our{' '}
                    <Link to="/terms" className="text-decoration-none">Terms and Conditions</Link>{' '}
                    and{' '}
                    <Link to="/privacy" className="text-decoration-none">Privacy Policy</Link>
                  </p>
                </div>
              </div>
              
              <div className="mt-4 text-center">
                <p className="mb-0">
                  Already have an account?{' '}
                  <Link to="/login" className="text-decoration-none fw-semibold">
                    Sign in with Google
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage; 